import React, { ReactNode } from 'react';

import PageLayout from '@/app/shell/page-layout';

interface PageContainerProps {
  children: ReactNode;
}

const PageContainer: React.FC<PageContainerProps> = ({ children }) => {
  return <PageLayout>{children}</PageLayout>;
};

export default PageContainer;
